import { applyLoginLanguage } from './languageOverride';

// Stores the same session keys the email/password login writes
export function saveLoginSession(data) {
  localStorage.setItem('token', data.token);
  localStorage.setItem(
    'user',
    JSON.stringify({
      userId: data.userId,
      username: data.username,
      isAdmin: data.isAdmin,
      role: data.role,
      delegatedGroupCount: data.delegatedGroupCount || 0,
      avatar: data.avatar || null,
    })
  );
  localStorage.setItem('userId', data.userId);
  // A saved account language wins over the guest choice; without one, the guest choice stays
  applyLoginLanguage(data.language);
}
